import React from 'react'
import InstructorNavbar from "../components/instructor/InstructorNavbar"
import InstructorCoursecontentlist from '../components/courseContent/InstructorCoursecontentlist'

const InstructorCourseContentlistPage = () => {
  return (
    <>
    <InstructorNavbar/>
    <InstructorCoursecontentlist/>
    </>

  )
}

export default InstructorCourseContentlistPage